import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

var pl = {
  language: 'pl',
  country: 'pl',
  name: 'Polski',
  embeddedLocale: merge(error, login),
  flags: ['PL'],
};

export { pl as default };
